module.exports = __webpack_public_path__ + "static/media/23004608_1638424739566044_3164069446785219131_o-thumb.7a8d04f8.jpg";